import React from 'react';

import { Button } from 'components/shared/Button';
import { Icon } from 'components/shared/Icon';

import { InputField } from 'components/FormikFields';
import { FormikField } from 'components/FormikField';

import styles from './LessonGoals.module.scss';

const LessonGoals = ({
  goals,
  onAddGoalClick,
  onRemoveGoalClick,
}: {
  goals: any;
  onAddGoalClick: any;
  onRemoveGoalClick: any;
}) => (
  <div className={styles.goals}>
    <div className={styles.items}>
      {goals.map((_: any, goalIndex: any) => (
        <div className={styles.item} key={goalIndex}>
          <FormikField
            name={`goals[${goalIndex}]`}
            component={InputField}
            controlProps={{
              className: styles.itemControl,
              label: `Goal ${goalIndex + 1}`,
            }}
          />
          <Button
            variant="outlined"
            size="sm"
            mode="icon"
            iconName="trash"
            onClick={() => onRemoveGoalClick(goalIndex)}
          />
        </div>
      ))}
    </div>
    <Button
      className={styles.action}
      size="sm"
      variant="link"
      startIcon={<Icon name="plus" />}
      onClick={onAddGoalClick}
    >
      Add goal
    </Button>
  </div>
);

export default React.memo(LessonGoals) as any;
